import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { SimpleField } from "../../../../../components/fields/simpleField.jsx";

import countries from "i18n-iso-countries";

import i18n_iso_countries from "i18n-iso-countries/langs/en.json";
import React, { useEffect, useState } from "react";
import { SubmitButton } from "../../../../../components/fields/submitButton.jsx";
import { useResource } from "../../../../../hooks/useResource.js";
import { Button } from "../../../../../components/button";

export function SettingsAccountingPage() {
  let [accounting, setaccounting] = useState({});

  let { control, handleSubmit, reset, formState, watch } = useForm({
    resolver: zodResolver(
      zod.object({
        referenceFormat: zod.string(),
        referenceCurrentValue: zod.number(),
        dateFormat: zod.string().optional(),
        defaultCurrency: zod.string().optional(),
      })
    ),
  });
  countries.registerLocale(i18n_iso_countries);

  let accountService = useResource("accounts");

  useEffect(() => {
    accountService.get("me").then((data) => {
      setaccounting(data);
      reset(data);
    });
  }, []);

  let save = (d) => {
    return accountService.edit("me", d).then(() => {
      reset({}, { keepValues: true });
    });
  };
  return (
    <div className={"flex flex-col gap-3 p-3"}>
      {" "}
      <div className={"flex"}>
        <h2 className={"font-bold py-2 flex items-center flex-grow"}>
          Accounting
        </h2>
      </div>
      <p>Please set up your accounting preferences for the application here.</p>
      <form
        onSubmit={handleSubmit(save)}
        className={"flex flex-col gap-3"}
        style={{ maxWidth: 500 }}
      >
        <SimpleField
          name={"dateFormat"}
          label={"Date format"}
          type={"select"}
          select={{
            options: [
              {
                label: "Year / Month / Day",
                value: "yyyy-MM-dd",
              },
              {
                label: "Month / Day / Year",
                value: "MM-dd-yyyy",
              },
              {
                label: "Day / Month / Year",
                value: "dd-MM-yyyy",
              },
            ],
          }}
          control={control}
        />

        <SimpleField
          name={"defaultCurrency"}
          label={"Default currency"}
          control={control}
        />

        <SubmitButton formState={formState}>Save</SubmitButton>
      </form>
    </div>
  );
}
